import { render, staticRenderFns } from "./App.vue?vue&type=template&id=973a7b9e&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=973a7b9e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./App.vue?vue&type=style&index=1&id=973a7b9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973a7b9e",
  null
  
)

export default component.exports